module.exports = __webpack_public_path__ + "static/media/img29.1f81bb4e.JPG";